export default [
  {
    key: 'admin_name',
    value: '',
    label: 'マネージャID',
    rules: { minmax: { min: 6, max: 30 }, adminID: true },
    name: 'adminName',
    as: 'input',
  },
  {
    key: 'admin_display_name',
    value: '',
    label: 'マネージャ名',
    rules: { minmax: { min: 1, max: 100 } },
    name: 'adminDisplayName',
    as: 'input',
  },
  {
    key: 'password',
    value: '',
    label: 'パスワード',
    rules: { password: true, confirmed: 'passwordConfirm' },
    name: 'password',
    as: 'input',
    type: 'password',
  },
  {
    key: 'password_2',
    value: '',
    label: 'パスワード(確認）',
    rules: {
      confirmed: 'password',
      password: true,
    },
    name: 'passwordConfirm',
    as: 'input',
    type: 'password',
  },
  {
    key: 'level',
    label: 'マネージャタイプ',
    rules: { required: false },
    name: 'level',
    as: 'select',
    options: [
      { value: '', label: '' },
      { value: '管理者', label: '管理者' },
      { value: 'サブ管理者', label: 'サブ管理者' },
      { value: '閲覧者', label: '閲覧者' },
      { value: '広告配信者', label: '広告配信者' },
      { value: '許可なし', label: '許可なし' },
    ],
    value: '',
  },
]
